import {
  OTREQUEST_ALL,
  OTREQUEST_GET,
  OTREQUEST_PUT,
  OTREQUEST_DEL,
  OTREQUEST_POST,
  OTREQUEST_LOADING,
  OTREQUEST_ERROR,
  OTREQUEST_PENDING_COUNT,
} from '../../actions/types';

const initialState = {
  otRequest: null,
  isLoading: true,
  isCompleted: true,
  pendingCount: 0,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case OTREQUEST_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case OTREQUEST_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case OTREQUEST_ALL:
      return { ...action.payload, isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case OTREQUEST_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case OTREQUEST_PENDING_COUNT:
      return { ...state, pendingCount: action.payload };
    case OTREQUEST_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case OTREQUEST_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case OTREQUEST_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    default:
      return state;
  }
}
